import "./Loading.scss";
import { ReactComponent as LoadingIcon } from "../../images/loading.svg";

const Loading = ({ style }) => {
  return (
    <div className="loading" style={style}>
      <LoadingIcon height={80} width={80} />
    </div>
  );
};

export default Loading;
